import router from './router'
import criminalMessages from './localization'

export default {
  router,
  localization: criminalMessages,
}
